/**
 * DNS-related alert components
 */
import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

/**
 * Standard DNS propagation note — plain text, no alert chrome.
 */
export const DnsPropagationNote: React.FC = () => (
  <p className="text-sm text-muted-foreground">
    <strong className="text-foreground">Note:</strong> DNS changes can take up to 24-48 hours to propagate.
  </p>
);

/**
 * Domain added success message
 */
export const DomainAddedSuccess: React.FC = () => (
  <Alert variant="success">
    <CheckCircle />
    <AlertDescription>
      <strong className="font-medium">Domain added.</strong> Add the TXT record below to verify ownership.
    </AlertDescription>
  </Alert>
);

/**
 * Ownership verified success message
 */
export const OwnershipVerifiedSuccess: React.FC = () => (
  <Alert variant="success">
    <CheckCircle />
    <AlertDescription>
      <strong className="font-medium">Ownership verified.</strong> You can now attach this domain to a site from the site's settings page.
    </AlertDescription>
  </Alert>
);

/**
 * Routing configured success message
 */
export const RoutingConfiguredSuccess: React.FC = () => (
  <Alert variant="success">
    <CheckCircle />
    <AlertDescription>
      <strong className="font-medium">Routing configured.</strong> Your custom domain is ready to use.
    </AlertDescription>
  </Alert>
);

/**
 * Info box for adding domains
 */
export const AddDomainInfo: React.FC = () => (
  <Alert variant="default">
    <AlertDescription>
      Add your domain now and verify ownership. You can attach it to any site later.
    </AlertDescription>
  </Alert>
);
